import { render, staticRenderFns } from "./MotorStartPage.vue?vue&type=template&id=225ec4a6&scoped=true"
import script from "./MotorStartPage.vue?vue&type=script&lang=js"
export * from "./MotorStartPage.vue?vue&type=script&lang=js"
import style0 from "./MotorStartPage.vue?vue&type=style&index=0&id=225ec4a6&prod&lang=scss&scoped=true"
import style1 from "./MotorStartPage.vue?vue&type=style&index=1&id=225ec4a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ec4a6",
  null
  
)

export default component.exports